<template>
  <div>
    <div class="date-container">
      <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          :start-placeholder="date1"
          :end-placeholder="date2"
          format="yyyyMMdd"
      ></el-date-picker>
    </div>
    <el-table
        :data="data"
        border
        style="width: 100%;min-width: 1000px;"
        :stripe="true"
        height="85vh"
    >
      <el-table-column type="expand" style="background-color: grey">
        <template slot-scope="scope">
          <OrderDetail :OID="scope.row.OID"></OrderDetail>
        </template>
      </el-table-column>
      <el-table-column prop="OID" label="編號" min-width="10%"></el-table-column>
      <el-table-column prop="NAME" label="客戶名" min-width="20%"></el-table-column>
      <el-table-column prop="AMOUNT" label="品項總數" min-width="10%"></el-table-column>
      <el-table-column v-if='isAdmin' label="刪除" min-width="10%">
        <template scope="{row}">
          <el-button
              @click="confirmDelete(row)"
              type="primary"
          >刪除
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="DATE" label="日期" min-width="12%"></el-table-column>
      <el-table-column prop="MEMO" label="備註" min-width="50%">
        <template slot-scope="scope">
          <span>
            {{ scope.row.MEMO }}
            <el-button @click="onEdit(scope.row)">編輯</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {getAuth, orderDel, orderList, orderMemo} from "@/api";
import OrderDetail from "@/components/OrderDetail";

export default {
  name: "Order",
  components: {OrderDetail},
  data() {
    return {
      data: [],
      dateRange: [],
      date1: this.firstDayOfMonth(),
      date2: this.yyyymmdd(new Date())
    }
  },
  created() {
    this.getOrders()
  },
  computed: {
    auth() {
      return getAuth()
    },
    isAdmin() {
      return this.auth > 1
    }
  },
  watch: {
    dateRange(newVal) {
      if (!newVal || !Array.isArray(newVal)) {
        this.getOrders()
      } else {
        this.getOrders({
          SDATE: this.yyyymmdd(newVal[0]),
          EDATE: this.yyyymmdd(newVal[1])
        })
      }
    }
  },
  methods: {
    getOrders(data) {
      orderList(data)
          .then(({LIST}) => {
            this.data = LIST
            LIST.forEach(item => {
              item.edit = false
            })
          })
    },
    yyyymmdd(date) {
      const mm = date.getMonth() + 1; // getMonth() is zero-based
      const dd = date.getDate();

      return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
      ].join('');
    },
    firstDayOfMonth() {
      const date = new Date()
      const mm = date.getMonth() + 1; // getMonth() is zero-based
      const dd = date.getDate();

      return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        '01'
      ].join('');
    },
    onEdit(row) {
      this.$prompt('請輸入 MEMO', '提示', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '請勿輸入空白',
        inputValue: row.MEMO
      }).then(({value}) => {
        orderMemo({OID: row.OID, MEMO: value})
            .then(result => {
              row.MEMO = value
              this.$message.success('MEMO 修改成功')
            })
            .catch(reason => {
              const reasonStr = reason + ''
              this.$message.error(`MEMO 修改失敗 (${reasonStr.substr(reasonStr.indexOf('Error:') + 7)})`)
            })
      }).catch(() => {
        this.$message.info('取消輸入');
      });
    },
    confirmDelete(row) {
      this.$confirm('此操作将永久删除该訂單, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const {OID} = row
        orderDel({OID})
            .then(res => {
              const i = this.data.findIndex(el => el.OID === OID)
              this.data.splice(i, 1)
              this.$message.success('刪除成功');
            })
            .catch(e => {
              this.$message.error('刪除失敗')
            })
      }).catch(() => {
        this.$message.info('取消刪除')
      });
    }
  }
}
</script>

<style scoped>
.date-container {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}

</style>
